import { Input_Icon_default } from "./chunk-RSKFFVLA.js";
import { Input_Input_default } from "./chunk-SMBYUPEM.js";
import { Input_default } from "./chunk-JVSS7HRO.js";

// src/elements/Input/index.ts
var InputComponent = Input_default;
InputComponent.Icon = Input_Icon_default;
InputComponent.Icon.displayName = "Input.Icon";
InputComponent.Input = Input_Input_default;
InputComponent.Input.displayName = "Input.Input";
export { InputComponent };